module.exports = __webpack_public_path__ + "static/hondotove-vzelavani-ade7f0c0933e2547d0d5fb8d63bf011a.png";